/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: phonebooksActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Applications module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';

/**
 * Shared helpers for Phonebooks module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a phonebook in the form.
 * Pattern: /pbx/applications/phonebooks/new?duplicate={id}
 */
export const getPhonebookDuplicateUrl = (id: string | number): string =>
  `/pbx/applications/phonebooks/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given phonebook id.
 */
export const navigateToPhonebookDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getPhonebookDuplicateUrl(id));
};
